import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Form, } from 'react-bootstrap'



import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { Link, useNavigate } from 'react-router-dom'


import { userLogoutAction } from '../actions/userActions'
import exportToExcel from '../utils/ExportToExcel'
import ToJalaali from '../utils/ToJalaali'
import { BASE_URL } from '../constants/urlConstants'
import PersianText from '../components/PersianText'
import { fetchinquiryPasargad } from '../actions/pasargadReportActions'

function PasargadInquiryScreen() {

  const history = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const pasargadInquirys = useSelector(state => state.pasargadInquiry)
  const { error, loading, pasargadinquiry } = pasargadInquirys

  const TE = "Invalid token specified: must be a string"

  useEffect(() => {
    if (error === TE) {
      dispatch(userLogoutAction());
      history('/login?redirect=/profile');
    }
    if (!userInfo) {
      history('/login')
    }
  }, [history, userInfo, dispatch, error])

  const [selectedCode, setselectedCode] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [message, setMessage] = useState('')

 

  const handleSubmit = (e) => {
    e.preventDefault()//صفحه ریلود نمیشود
    if (!selectedCode) {
      setMessage('لطفا کد فاکتور کنید !')
    } else {
      setMessage('')
      dispatch(fetchinquiryPasargad(selectedCode))
      
      setselectedCode('')
    }
  }

  console.log(pasargadinquiry)
  return (

    <div>
      {
        loading ? <Loader />
          : error ? <Message variant='danger' text={error} />
            : message ? <Message variant='danger' text={message} />
              : <></>
      }
      <p className='text-danger large mt-3'>گزارش تحویل :</p>
      <Row>
        <form onSubmit={handleSubmit}>
          <Col md={12}>
            <Row>   
              {userInfo.name == "mina" ? (
              <Col md={3} className='pt-3'>
                    <div>
                  <Form.Group controlId='trackcode'>
                    <Form.Label></Form.Label>
                    <Form.Control
                      type='text'
                      name="option"
                      placeholder='کد رهگیری'
                      value={selectedCode}
                      onChange={(e) => setselectedCode(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                </div>
               
              </Col>
               ) : ""}
                
            </Row>
            <Row>
              <div className="d-grid gap-2 d-md-block col-3 p-3">
                <button className="btn btn-primary" type="submit">نمایش</button>
              </div>
            </Row>
          </Col>
        </form>
      </Row>
      
      {/* <Row>

        <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
          <thead>
            <tr className='table-warning'>
              <td className='table-warning text-danger'>ردیف</td>
              <td className='table-warning text-danger'>کد رهگیری</td>
              <td className='table-warning text-danger'>نام</td>
              <td className='table-warning text-danger'>پک مربوطه</td>
              <td className='table-warning text-danger'>تاریخ تایید پرداخت</td>
              <td className='table-warning text-danger'>تاریخ پرداخت</td>
              <td className='table-warning text-danger'>شماره فاکتور</td>
              <td className='table-warning text-danger'> شماره کارت</td>
              <td className='table-warning text-danger'>شماره پیگیری</td>
            </tr>
          </thead>
          <tbody>
            {pasargadreport.map((items, index) => (
              <tr className='table-warning'>
                <td className='table-warning'>{index + 1}</td>
                <td className='table-warning'>
                  
                    <PersianText> {items.customer?.track_code || '-'}</PersianText>
                  
                </td>
                <td className='table-warning'>{items.customer?.customer?.name || '-'}</td>

                <td className='table-warning'><PersianText>کیت شماره {items.customer?.categoryKit || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.customer?.paidAt ? ToJalaali(items.customer.paidAt) : '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.invoiceDate ? ToJalaali(items.invoiceDate) : '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.invoice || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.cardNo || '-'}</PersianText></td>
                <td className='table-warning'><PersianText>{items.trackId || '-'}</PersianText></td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Row> */}

    </div>



  );
}

export default PasargadInquiryScreen
